<script setup lang="ts">
const { result, onSubmit, onReset, isSubmitting } = useAuthLoginForm();
</script>

<template>
  <UiFormWrapper :result="result" @submit="onSubmit" @reset="onReset">
    <FieldText name="username" type="text" label="Identifiant ou adresse courriel" required />
    <FieldText name="password" type="password" label="Mot de passe" required />
    <FieldCheckbox name="remember" label="Se souvenir de moi" />
    <UiSubmitButton :is-submitting="isSubmitting">
      Connexion
    </UiSubmitButton>
    <template #success="{ data }">
      <div class="message prose">
        <p class="text-success" v-html="data.message" />
      </div>
    </template>
  </UiFormWrapper>
</template>
